import React from 'react';
import { Button } from 'react-bootstrap';
import '../../../styles/containers/SavingsCalculator/components/next-button.scss';
function NextButton({handleClick,selectedEarning}) {
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
            <button className={`next-button-container ${selectedEarning == null ? "disabled-button" : ""}`} onClick={handleClick} 
             disabled={selectedEarning==null? true: false}
            >Next</button>
        </div>


    )
}

export default NextButton
